import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import * as PlaceholdersActions from './placeholder.action';
import { GeneralSignalRResponse } from 'src/app/services/signal-r/general-signal-r-response';
import { SignalRService } from 'src/app/services/signal-r/signal-r.service';
import { SignalRAction } from 'src/app/services/signal-r/signalr-enums';
import { Channels } from 'src/app/store/channels';

@Injectable({
  providedIn: 'root'
})
export class PlaceholdersStoreAndListenersService {
  constructor(private store: Store, private signalRService: SignalRService) { }
  initStore() {
    this.store.dispatch(new PlaceholdersActions.PlaceholdersRefresh());
  }

  initListeners() {
    this.signalRService.hubConnection?.on(Channels.PLACEHOLDERS, (data: GeneralSignalRResponse) => {
      this.signalRService.setSender(data.userID);
      switch (data.action) {
        case SignalRAction.Add:
          this.store.dispatch(new PlaceholdersActions.PlaceholdersCreate(data.obj));
          break;

        case SignalRAction.Update:
          this.store.dispatch(new PlaceholdersActions.PlaceholdersUpdate(data.id, data.obj));
          break;

        case SignalRAction.Delete:
          this.store.dispatch(new PlaceholdersActions.PlaceholdersDelete(data.id));
          break;

        case SignalRAction.Get:
          this.store.dispatch(new PlaceholdersActions.PlaceholdersRefresh());
          break;
      }
    });
  }
}
